<template>

  <div id="content" class="sections">
    <Head>
      <!-- Primary Meta Tags -->
      <title>{{ changeMetatagHtml($t("handTools.metaTitle")) }}</title>

      <link rel="canonical" href="https://komatools.com/es/herramientas-manuales"/>
      <link rel="alternate" href="https://komatools.com/es/herramientas-manuales" hreflang="es"/>
      <link rel="alternate" href="https://komatools.com/en/hand-tools" hreflang="en"/>
      <link rel="alternate" href="https://komatools.com/fr/outils-manuels" hreflang="fr"/>
      <link rel="alternate" href="https://komatools.com/es/herramientas-manuales" hreflang="x-default"/>

      <meta name="title" :content="changeMetatagHtml($t('handTools.metaTitle'))">
      <meta name="description" :content="changeMetatagHtml($t('handTools.metaDescription'))">

      <!-- Open Graph / Facebook -->
      <meta property="og:type" content="website">
      <meta property="og:url" content="https://komatools.com/">
      <meta property="og:title" :content="changeMetatagHtml($t('handTools.metaTitle'))">
      <meta property="og:description" :content="changeMetatagHtml($t('handTools.metaDescription'))">
      <meta property="og:image" content="https://komatools.com/img/komatoolsSocial.jpg">

      <!-- Twitter -->
      <meta property="twitter:card" content="summary_large_image">
      <meta property="twitter:url" content="https://komatools.com/">
      <meta property="twitter:title" :content="changeMetatagHtml($t('handTools.metaTitle'))">
      <meta property="twitter:description" :content="changeMetatagHtml($t('handTools.metaDescription'))">
      <meta property="twitter:image" content="https://komatools.com/img/komatoolsSocial.jpg">
    </Head>

    <div class="section light paddingBigger">
      <div>
        <div class="banner centered">
          <div class="header">
            <h1 class="title">{{ $t("handTools.title") }}</h1>
            <h2 v-html="$t('handTools.subTitle')" class="subTitle"></h2>
          </div>
        </div>

        <details>
          <summary v-html="$t('handTools.summary.title')"></summary>
          <p v-html="$t('handTools.summary.descriptionParagraph1')"></p>
          <p v-html="$t('handTools.summary.descriptionParagraph2')"></p>
          <p v-html="$t('handTools.summary.descriptionParagraph3')"></p>
          <p v-html="$t('handTools.summary.descriptionParagraph4')"></p>
          <p v-html="$t('handTools.summary.descriptionParagraph5')"></p>
        </details>

        <div class="options buttons wrap centered">
          <a class="button accent" v-for="(filter, index) in filtersRef" :key="index">
                    <span
                        @click="filterData(filter)"
                        :class="{ active: filter === activeFilter }"
                    >
                      {{ $t(filter.text) }}
                    </span>
          </a>
        </div>

        <div class="banner centered" v-if="error">
          <p v-html="$t(error)"></p>
        </div>

        <div v-else>
          <ArticlesList :articles="searchedArticles"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import getArticles from '../../composables/getArticles'
import GENERIC_VARIABLES from "../../../config";
import ArticlesList from '@/components/ArticlesList.vue'
import {Head} from '@vueuse/head'
import {computed, ref} from 'vue'
import {useRoute} from "vue-router";

export default {
  name: "HandTools",
  components: {ArticlesList, Head},
  setup() {
    const route = useRoute();

    const subcategories = [
      'ELK120A00008',
      'ELK120A00015',
      'ELK120A01098',
      'ELK120A01285',
      'ELK120A01667',
      'ELK120A01680',
      'ELK120A01740',
      'ELK120A01040',
      'ELK120A01045',
      'ELK120A01075',
      'ELK120A01670',
      'ELK120A01750',
      'ELK120A01810',
      'ELK120A01895',
      'ELK120A01980',
    ]

    const filterMap = {
      all: 0,
      cuttingTools: 1,
      measuringTools: 2,
      workshopEquipment: 3
    }

    const filtersRef = ref([
      {text: 'filtersArticles.all.text', code: []},
      {text: 'filtersArticles.cuttingTools.text', code: ['ELK120A00008', 'ELK120A01098']},
      {text: 'filtersArticles.measuringTools.text', code: ['ELK120A00015', 'ELK120A01285', 'ELK120A01667', 'ELK120A01740', 'ELK120A01680']},
      {text: 'filtersArticles.workshopEquipment.text', code: ['ELK120A01040', 'ELK120A01045', 'ELK120A01075', 'ELK120A01670', 'ELK120A01750',
        'ELK120A01810', 'ELK120A01895', 'ELK120A01980'
      ]},
    ])

    const activeFilter = ref(filtersRef.value[0]);

    const filterFromRoute = filterMap[route.query.filter];
    if (filterFromRoute) {
      activeFilter.value = filtersRef.value[filterFromRoute];
    }

    const {articles, error, load} = getArticles(GENERIC_VARIABLES.PRODUCT_BRAND, subcategories)

    load()

    /**
     * This is a function to remove the special character | from javascript
     * More information: https://stackoverflow.com/questions/5796718/html-entity-decode
     */
    const changeMetatagHtml = (html) => {
      let txt = document.createElement("textarea");
      txt.innerHTML = html;
      return txt.value;
    }

    const searchedArticles = computed(() => {
      const activeCodes = Array.isArray(activeFilter.value?.code) ? activeFilter.value.code : [];

      if (activeCodes.length === 0) {
        return articles.value;
      }

      return articles.value.filter((article) =>
          activeCodes.includes(article.subcategoryCode)
      );
    });

    const filterData = (filter) => {
      activeFilter.value = filter;
    }

    return {
      searchedArticles,
      filtersRef,
      activeFilter,
      error,
      GENERIC_VARIABLES,
      subcategories,
      changeMetatagHtml,
      filterData
    }
  }
}
</script>
